import { defineMessages } from 'react-intl';
export default defineMessages({
    appVersion: {
        id: 'settings.appVersion',
        defaultMessage: 'SmartMixin v{version}'
    },
    appearance: {
        id: 'settings.appearance',
        defaultMessage: 'Appearance'
    },
    arabic: {
        id: 'settings.arabic',
        defaultMessage: 'Arabic'
    },
    bulgarian: {
        id: 'settings.bulgarian',
        defaultMessage: 'Bulgarian'
    },
    catalan: {
        id: 'settings.catalan',
        defaultMessage: 'Catalan'
    },
    chartGestures: {
        id: 'settings.chartGestures',
        defaultMessage: 'Gestures on charts'
    },
    chartGesturesDescription: {
        id: 'settings.chartGesturesDescription',
        defaultMessage: 'Swiping on charts changes the time period, pinching charts changes time scale'
    },
    choiceCount: {
        id: 'settings.choiceCount',
        defaultMessage: '{count, plural, one {# available} other {# available}}'
    },
    contactUs: {
        id: 'settings.contactUs',
        defaultMessage: 'Contact Us'
    },
    contactUsDescription: {
        id: 'settings.contactUsDescription',
        defaultMessage: 'Get help or send feedback'
    },
    croatian: {
        id: 'settings.croatian',
        defaultMessage: 'Croatian'
    },
    czech: {
        id: 'settings.czech',
        defaultMessage: 'Czech'
    },
    danish: {
        id: 'settings.danish',
        defaultMessage: 'Danish'
    },
    dark: {
        id: 'settings.dark',
        defaultMessage: 'Dark theme'
    },
    dataDisplay: {
        id: 'settings.dataDisplay',
        defaultMessage: 'Data display'
    },
    dateAndTime: {
        id: 'settings.dateAndTime',
        defaultMessage: 'Date and time'
    },
    donateTitle: {
        id: 'settings.donateTitle',
        defaultMessage: 'Support SmartMixin'
    },
    donateDescription: {
        id: 'settings.donateDescription',
        defaultMessage: "SmartMixin is built by a small team. If you find it useful, you can support its development with a one-time donation of any amount. It's a gift — it doesn't change your plan or unlock any features."
    },
    donateButton: {
        id: 'settings.donateButton',
        defaultMessage: 'Make a donation'
    },
    donateSuccessTitle: {
        id: 'settings.donateSuccessTitle',
        defaultMessage: 'Thank you for your support!'
    },
    donateSuccessBody: {
        id: 'settings.donateSuccessBody',
        defaultMessage: 'Your donation helps keep SmartMixin running and improving. We truly appreciate it.'
    },
    dragToReorder: {
        id: 'settings.dragToReorder',
        defaultMessage: 'Drag to reorder'
    },
    dutch: {
        id: 'settings.dutch',
        defaultMessage: 'Dutch'
    },
    english: {
        id: 'settings.english',
        defaultMessage: 'English'
    },
    french: {
        id: 'settings.french',
        defaultMessage: 'French'
    },
    german: {
        id: 'settings.german',
        defaultMessage: 'German'
    },
    gestures: {
        id: 'settings.gestures',
        defaultMessage: 'Gestures'
    },
    greek: {
        id: 'settings.greek',
        defaultMessage: 'Greek'
    },
    hungarian: {
        id: 'settings.hungarian',
        defaultMessage: 'Hungarian'
    },
    italian: {
        id: 'settings.italian',
        defaultMessage: 'Italian'
    },
    japanese: {
        id: 'settings.japanese',
        defaultMessage: 'Japanese'
    },
    korean: {
        id: 'settings.korean',
        defaultMessage: 'Korean'
    },
    language: {
        id: 'settings.language',
        defaultMessage: 'Language'
    },
    languageDescription: {
        id: 'settings.languageDescription',
        defaultMessage: 'Preferred language'
    },
    light: {
        id: 'settings.light',
        defaultMessage: 'Light theme'
    },
    mapTheme: {
        id: 'settings.mapTheme',
        defaultMessage: 'Map theme'
    },
    mapThemeAuto: {
        id: 'settings.mapThemeAuto',
        defaultMessage: 'Auto'
    },
    mapThemeDark: {
        id: 'settings.mapThemeDark',
        defaultMessage: 'Dark'
    },
    mapThemeDescription: {
        id: 'settings.mapThemeDescription',
        defaultMessage: "Auto matches the app's theme."
    },
    mapThemeLight: {
        id: 'settings.mapThemeLight',
        defaultMessage: 'Light'
    },
    measurementUnits: {
        id: 'settings.measurementUnits',
        defaultMessage: 'Measurement units'
    },
    netatmoDashboard: {
        id: 'settings.netatmoDashboard',
        defaultMessage: 'Netatmo dashboard'
    },
    netatmoLayoutCards: {
        id: 'settings.netatmoLayoutCards',
        defaultMessage: 'Card list'
    },
    netatmoLayoutCardsDescription: {
        id: 'settings.netatmoLayoutCardsDescription',
        defaultMessage: 'One card per module, all on one scroll'
    },
    netatmoLayoutClassic: {
        id: 'settings.netatmoLayoutClassic',
        defaultMessage: 'Classic'
    },
    netatmoLayoutClassicDescription: {
        id: 'settings.netatmoLayoutClassicDescription',
        defaultMessage: 'Two cards, swipe between modules'
    },
    netatmoNewLayoutNotice: {
        id: 'settings.netatmoNewLayoutNotice',
        defaultMessage: 'New dashboard layout: one card per module.'
    },
    netatmoSwitchBackToClassic: {
        id: 'settings.netatmoSwitchBackToClassic',
        defaultMessage: 'Switch back to Classic'
    },
    netatmoSwitchToLayout: {
        id: 'settings.netatmoSwitchToLayout',
        defaultMessage: 'Switch to {layout}'
    },
    norwegian: {
        id: 'settings.norwegian',
        defaultMessage: 'Norwegian'
    },
    notificationsSection: {
        id: 'settings.notificationsSection',
        defaultMessage: 'Notifications'
    },
    ongoingNotificationEnabled: {
        id: 'settings.ongoingNotificationEnabled',
        defaultMessage: 'Enable ongoing notification'
    },
    ongoingNotificationMetrics: {
        id: 'settings.ongoingNotificationMetrics',
        defaultMessage: 'Displayed metrics'
    },
    ongoingNotificationPermissionRequired: {
        id: 'settings.ongoingNotificationPermissionRequired',
        defaultMessage: 'Notification permission is required'
    },
    ongoingNotificationPreviewHint: {
        id: 'settings.ongoingNotificationPreviewHint',
        defaultMessage: 'Preview — turn the widget on to show it'
    },
    ongoingNotificationStatusBar: {
        id: 'settings.ongoingNotificationStatusBar',
        defaultMessage: 'Status bar'
    },
    polish: {
        id: 'settings.polish',
        defaultMessage: 'Polish'
    },
    portuguese: {
        id: 'settings.portuguese',
        defaultMessage: 'Portuguese'
    },
    preferencesSection: {
        id: 'settings.preferencesSection',
        defaultMessage: 'Preferences'
    },
    privacyPolicy: {
        id: 'settings.privacyPolicy',
        defaultMessage: 'Privacy policy'
    },
    russian: {
        id: 'settings.russian',
        defaultMessage: 'Russian'
    },
    serbian: {
        id: 'settings.serbian',
        defaultMessage: 'Serbian'
    },
    settings: {
        id: 'settings.settings',
        defaultMessage: 'Settings'
    },
    settingsPageTitle: {
        id: 'settings.settingsPageTitle',
        defaultMessage: 'Settings - {page}'
    },
    slovak: {
        id: 'settings.slovak',
        defaultMessage: 'Slovak'
    },
    dailyDetailByPeriods: {
        id: 'settings.dailyDetailByPeriods',
        defaultMessage: 'Daily detail by periods'
    },
    dailyDetailByPeriodsDescription: {
        id: 'settings.dailyDetailByPeriodsDescription',
        defaultMessage: 'Group the 24 hours into night, morning, afternoon and evening — the same split the daily summary sentence uses.'
    },
    smallDecimals: {
        id: 'settings.smallDecimals',
        defaultMessage: 'Small decimals'
    },
    smallDecimalsDescription: {
        id: 'settings.smallDecimalsDescription',
        defaultMessage: 'Display decimal digits in a smaller size'
    },
    windDirectionConvention: {
        id: 'settings.windDirectionConvention',
        defaultMessage: 'Wind direction arrow'
    },
    windDirectionConventionDescription: {
        id: 'settings.windDirectionConventionDescription',
        defaultMessage: 'Choose how wind direction arrows are displayed'
    },
    windDirectionOceanographic: {
        id: 'settings.windDirectionOceanographic',
        defaultMessage: 'Flow direction'
    },
    windDirectionOceanographicDescription: {
        id: 'settings.windDirectionOceanographicDescription',
        defaultMessage: 'Arrow points where the wind blows to (oceanographic convention)'
    },
    windDirectionMeteorological: {
        id: 'settings.windDirectionMeteorological',
        defaultMessage: 'Origin direction'
    },
    windDirectionMeteorologicalDescription: {
        id: 'settings.windDirectionMeteorologicalDescription',
        defaultMessage: 'Arrow points where the wind comes from (meteorological convention)'
    },
    spanish: {
        id: 'settings.spanish',
        defaultMessage: 'Spanish'
    },
    statusBarWidget: {
        id: 'settings.statusBarWidget',
        defaultMessage: 'Status Bar Widget'
    },
    statusBarWidgetDescription: {
        id: 'settings.statusBarWidgetDescription',
        defaultMessage: 'Always-visible weather data'
    },
    subscriptionSection: {
        id: 'settings.subscriptionSection',
        defaultMessage: 'Subscription'
    },
    supportSection: {
        id: 'settings.supportSection',
        defaultMessage: 'Support'
    },
    swedish: {
        id: 'settings.swedish',
        defaultMessage: 'Swedish'
    },
    systemTheme: {
        id: 'settings.systemTheme',
        defaultMessage: 'System theme'
    },
    themeDarkShort: {
        id: 'settings.themeDarkShort',
        defaultMessage: 'Dark'
    },
    themeLightShort: {
        id: 'settings.themeLightShort',
        defaultMessage: 'Light'
    },
    themeSystemShort: {
        id: 'settings.themeSystemShort',
        defaultMessage: 'System'
    },
    termsOfService: {
        id: 'settings.termsOfService',
        defaultMessage: 'Terms of service'
    },
    turkish: {
        id: 'settings.turkish',
        defaultMessage: 'Turkish'
    },
    ukrainian: {
        id: 'settings.ukrainian',
        defaultMessage: 'Ukrainian'
    },
    units: {
        id: 'settings.units',
        defaultMessage: 'Units'
    },
    unitsDescription: {
        id: 'settings.unitsDescription',
        defaultMessage: 'Measurement units displayed within the application'
    },
    update: {
        id: 'settings.update',
        defaultMessage: 'Update'
    }
});
